import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";
import { DebtAgreementsDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const DebtAgreementsDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({
    forType: UploadDocumentType.COMPANY_DEBT_AGREEMENT,
  });

  return (
    <OnboardingLayout
      variant="wide"
      title={intl.formatMessage(MESSAGES.debtAgreementsTitle)}
      actions={{ primary: primaryAction, secondary: secondaryAction }}
    >
      <Flex maxWidth="550px">
        <DebtAgreementsDocumentUpload />
      </Flex>
    </OnboardingLayout>
  );
};
